// extracted by mini-css-extract-plugin
export default {"card":"card_card__D+ppZ","head":"card_head__v1x-6","title":"card_title__-vWzK"};